import { ref } from 'vue';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1262834e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left_container"
};
const _hoisted_2 = {
  key: 1,
  class: "left_container_bom d-flex"
};
import { computed } from 'vue';
import roleHooks from '@/hooks/roleV2Hooks';
import slideHeader from '@/views/layout/slideHeader.vue';
import slideLeft from './slideLeft.vue';
import slideRight from './slideRight.vue';
import editHelp from './editHelp.vue';
import Login from '@/views/login/index.vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['close'],
  setup(__props, {
    emit: emits
  }) {
    const store = useStore();
    const {
      onwerAllRoleList
    } = roleHooks();
    const select_role_ac = ref(0);
    const close = () => {
      noEdit.value = false;
      emits('close', false);
    };
    const roleList = computed(() => onwerAllRoleList.value);
    const token = computed(() => store.state.userInfo.token || store.state.userInfo.wwToken);
    // 点击切换角色并查询角色文件资料存入store
    const changeAc = async index => {
      select_role_ac.value = index;
    };
    const noEdit = ref(false);
    const isEditOrAdd = ref('edit');
    const editClick = type => {
      // console.log(roleList.value[select_role_ac.value])
      let roleInfo = roleList.value[select_role_ac.value];
      if (roleInfo.roleType != 2) {
        ElMessage.warning({
          message: '当前角色不能编辑'
        });
        return;
      }
      noEdit.value = type;
      isEditOrAdd.value = 'edit';
    };
    const addClick = type => {
      select_role_ac.value = 0;
      noEdit.value = type;
      isEditOrAdd.value = 'add';
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(slideHeader, {
        onClose: close
      }), !_unref(token) ? (_openBlock(), _createBlock(Login, {
        key: 0
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives(_createVNode(slideLeft, {
        onEditClick: addClick,
        select_role_ac: _unref(select_role_ac),
        roleList: _unref(roleList),
        onChangeAc: changeAc
      }, null, 8, ["select_role_ac", "roleList"]), [[_vShow, !_unref(noEdit)]]), _withDirectives(_createVNode(slideRight, {
        onEditClick: editClick,
        roleId: _unref(roleList).length ? _unref(roleList)[_unref(select_role_ac)].id : ''
      }, null, 8, ["roleId"]), [[_vShow, !_unref(noEdit)]]), _unref(noEdit) ? (_openBlock(), _createBlock(editHelp, {
        key: 0,
        isEditOrAdd: _unref(isEditOrAdd),
        select_role_ac: _unref(select_role_ac),
        onBack: addClick
      }, null, 8, ["isEditOrAdd", "select_role_ac"])) : _createCommentVNode("", true)]))]);
    };
  }
});